import {FC, HTMLAttributes} from "react";
import css from './Button.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(css);

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
    disabled?: boolean;
    href?: string;
}

const Button: FC<ButtonProps> = ({disabled = false, onClick, children, href = '', className}) => {

    return (
        href ? <a href={href} target={'_blank'}>
                <button onClick={onClick} disabled={disabled} className={cx(css.button, className)}>
                    {children}
                </button>
            </a>
            : <button onClick={onClick} disabled={disabled} className={cx(css.button, className)}>
                {children}
            </button>

    )
}

export default Button;